/**
 * The MarketBrewer wordmark as the sign-in page and the CRM set it: "Market"
 * in ink, "Brewer" in the true metro orange (--accent), mixed case. Text
 * rather than an image, so it follows the theme and the text-size control.
 * Never an "M" badge, never all caps.
 *
 * --accent, not --accent-text, in both themes: a logo has no contrast
 * requirement (WCAG 1.4.3 exempts logotypes), and the brand is #ED8B00.
 * Words that must be read take --accent-text instead.
 *
 * Inside a `group` link the halves swap colours on hover, as the CRM's
 * masthead does; anywhere else the group-hover classes are inert.
 */

export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span
      className={`font-bold tracking-tight text-primary transition-colors group-hover:text-accent ${className}`}
    >
      Market
      <span className="text-accent transition-colors group-hover:text-primary">Brewer</span>
    </span>
  );
}
